import axios from "axios";

// Same-origin: Das Ingress routet /api auf jeder Domain zum Backend — nur lokale
// Entwicklung (localhost:3000) braucht die konfigurierte Backend-URL.
const isLocalDev = ["localhost", "127.0.0.1"].includes(window.location.hostname);
const baseOrigin = isLocalDev ? process.env.REACT_APP_BACKEND_URL : window.location.origin;

const api = axios.create({
  baseURL: `${baseOrigin}/api`,
  withCredentials: true,
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return "Etwas ist schiefgelaufen. Bitte erneut versuchen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
